import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { getGalleryItems } from '../../services/galleryService';

const Home = () => {
  // Define styles for animations
  const fadeInUpStyle = `
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;
  const [notices, setNotices] = useState([]);


  useEffect(() => {
    // Fetch recent notices
    const fetchNotices = async () => {
      try {
        const response = await api.get('/notices');
        setNotices(response.data.data.slice(0, 6)); // Get latest 6 notices
      } catch (error) {
        console.error('Error fetching notices:', error);
      }
    };



    fetchNotices();
  }, []);

  const [isVisible, setIsVisible] = useState({});
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  
  useEffect(() => {
    // Set page loaded after initial render for animations
    setTimeout(() => setIsPageLoaded(true), 100);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsVisible(prev => ({
            ...prev,
            [entry.target.id]: entry.isIntersecting
          }));
        });
      },
      { threshold: 0.1 }
    );
    
    document.querySelectorAll('[id]').forEach((el) => {
      observer.observe(el);
    });
    
    return () => observer.disconnect();
  }, []);

  // Testimonials data
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Parent",
      content: "EduManage has transformed our child's learning experience. The teachers are dedicated and the curriculum is comprehensive.",
      rating: 5,
      avatar: "👩‍👧"
    },
    {
      name: "Michael Chen",
      role: "Student",
      content: "The platform helped me stay organized and track my progress effectively. Great resources and support system.",
      rating: 5,
      avatar: "🎓"
    },
    {
      name: "Dr. Priya Sharma",
      role: "Teacher",
      content: "As a teacher, EduManage simplifies lesson planning and student management. Highly recommended for educational institutions.",
      rating: 5,
      avatar: "👨‍🏫"
    },
    {
      name: "David Wilson",
      role: "Principal",
      content: "EduManage has revolutionized our school administration. The streamlined processes save us countless hours.",
      rating: 5,
      avatar: "👨‍💼"
    },
    {
      name: "Emily Davis",
      role: "Alumni",
      content: "The foundation I received through EduManage prepared me perfectly for university. The critical thinking skills are invaluable.",
      rating: 5,
      avatar: "👩‍🎓"
    }
  ];

  const CountUp = ({ end, duration = 2000 }) => {
    const [count, setCount] = useState(0);
    const [hasAnimated, setHasAnimated] = useState(false);
    
    useEffect(() => {
      if (isVisible.statsSection && !hasAnimated) {
        setHasAnimated(true);
        let start = 0;
        const increment = end / (duration / 16);
        const timer = setInterval(() => {
          start += increment;
          if (start >= end) {
            setCount(end);
            clearInterval(timer);
          } else {
            setCount(Math.floor(start));
          }
        }, 16);
        
        return () => clearInterval(timer);
      }
    }, [end, duration, hasAnimated]);
    
    return `${count}+`;
  };

  const [isLoaded, setIsLoaded] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showChatbot, setShowChatbot] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentGalleryIndex, setCurrentGalleryIndex] = useState(0);
  const [darkMode, setDarkMode] = useState(false);
  const [ripple, setRipple] = useState({ x: 0, y: 0, size: 0, active: false });
  const [hideAnnouncement, setHideAnnouncement] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    // Set page loaded after initial render for animations
    setTimeout(() => {
      setIsLoaded(true);
      setPageLoading(false);
    }, 500);
    
    // Auto-rotate testimonials
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    
    // Handle ESC key for lightbox
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && lightboxOpen) {
        closeLightbox();
      }
    };
    
    window.addEventListener('keydown', handleEscKey);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [lightboxOpen, testimonials.length]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Implement search functionality
      console.log('Searching for:', searchQuery);
    }
  };



  const openLightbox = (index) => {
    console.log('Opening lightbox for index:', index, 'with image:', galleryImages[index], 'gallery length:', galleryImages.length);
    if (galleryImages && galleryImages.length > 0 && index >= 0 && index < galleryImages.length) {
      setCurrentGalleryIndex(index);
      setSelectedImage(galleryImages[index]);
      setLightboxOpen(true);
    }
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };
  
  const handleRipple = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;
    
    setRipple({ x, y, size, active: true });
    
    setTimeout(() => {
      setRipple({ x: 0, y: 0, size: 0, active: false });
    }, 600);
  };



  const nextImage = () => {
    if (galleryImages && galleryImages.length > 0) {
      const newIndex = (currentGalleryIndex + 1) % galleryImages.length;
      setCurrentGalleryIndex(newIndex);
      setSelectedImage(galleryImages[newIndex]);
    }
  };

  const prevImage = () => {
    if (galleryImages && galleryImages.length > 0) {
      const newIndex = (currentGalleryIndex - 1 + galleryImages.length) % galleryImages.length;
      setCurrentGalleryIndex(newIndex);
      setSelectedImage(galleryImages[newIndex]);
    }
  };

  const [galleryImages, setGalleryImages] = useState([]);
  const [logoImages, setLogoImages] = useState([]);

  useEffect(() => {
    // Fetch gallery images
    const fetchGalleryImages = async () => {
      try {
        const response = await getGalleryItems({
          limit: 12, // Get more images
          sort: '-createdAt'
        });
        if (response.data.success && response.data.data) {
          // Separate logo images from other gallery images
          const allImages = response.data.data;
          const logos = allImages.filter(img => img.category && img.category.toLowerCase().includes('logo'));
          const otherImages = allImages.filter(img => !(img.category && img.category.toLowerCase().includes('logo')));
          
          setLogoImages(logos);
          setGalleryImages(otherImages);
        } else {
          // Fallback to static images if API returns no data
          const fallbackImages = [
            { id: 1, imageUrl: '', title: "School Building", category: 'Campus' },
            { id: 2, imageUrl: '', title: "Classroom", category: 'Academic' },
            { id: 3, imageUrl: '', title: "Sports Event", category: 'Sports' },
            { id: 4, imageUrl: '', title: "School Event", category: 'Events' }
          ];
          setGalleryImages(fallbackImages);
          setLogoImages([]);
        }
      } catch (error) {
        console.error('Error fetching gallery images:', error);
        // Fallback to static images if API fails
        const fallbackImages = [
          { id: 1, imageUrl: '', title: "School Building", category: 'Campus' },
          { id: 2, imageUrl: '', title: "Classroom", category: 'Academic' },
          { id: 3, imageUrl: '', title: "Sports Event", category: 'Sports' },
          { id: 4, imageUrl: '', title: "School Event", category: 'Events' }
        ];
        setGalleryImages(fallbackImages);
        setLogoImages([]);
      }
    };

    fetchGalleryImages();
  }, []);



  // Scroll to top button component
  const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      };

      window.addEventListener('scroll', toggleVisibility);
      
      return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    return (
      <button
        type="button"
        onClick={scrollToTop}
        className={`fixed bottom-6 right-6 w-12 h-12 rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700 transition-colors duration-300 z-50 flex items-center justify-center ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        aria-label="Scroll to top"
        tabIndex="0"
      >
        ↑
      </button>
    );
  };

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-50 to-white'} font-sans`}>
      <style>{`
        ${fadeInUpStyle}
        html {
          scroll-behavior: smooth;
        }
        
        /* Marquee animation for announcement */
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        
        .animate-marquee {
          animation: marquee 15s linear infinite;
        }
        
        /* Fade in slide animation */
        @keyframes fadeInSlide {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeInSlide {
          animation: fadeInSlide 0.5s ease-out forwards;
        }
        
        /* Staggered fade-in animation for sections */
        @keyframes staggerFadeIn {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-staggerFadeIn {
          animation: staggerFadeIn 0.6s ease-out forwards;
        }
        
        /* Ripple effect */
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        .animate-ripple {
          animation: ripple 0.6s linear;
        }
        
        /* Card hover animation */
        .transition-transform {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        /* Underline animation for links */
        .link-underline {
          position: relative;
          will-change: auto;
        }
        
        .link-underline::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background-color: currentColor;
          transition: width 0.3s ease;
          will-change: width;
        }
        
        .link-underline:hover::after {
          width: 100%;
        }
        
        /* Respect reduced motion preference */
        @media (prefers-reduced-motion: reduce) {
          *,
          *::before,
          *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
          
          html {
            scroll-behavior: auto;
          }
        }
      `}</style>
      
      {/* Dark Mode Toggle */}
      <div className="fixed top-4 right-4 z-50">
        <button 
          onClick={() => setDarkMode(!darkMode)}
          className={`p-2 rounded-full ${darkMode ? 'bg-yellow-400 text-gray-900' : 'bg-gray-800 text-yellow-400'} shadow-lg hover:scale-110 transition-transform duration-300`}
        >
          {darkMode ? '☀️' : '🌙'}
        </button>
      </div>
      
      {pageLoading ? (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-50 to-white">
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-blue-600 font-semibold">Loading EduManage...</p>
          </div>
        </div>
      ) : (
        <>
          {/* Announcement Banner */}
          {!hideAnnouncement && (
            <div className={`${darkMode ? 'bg-gradient-to-r from-purple-600 to-blue-600' : 'bg-gradient-to-r from-blue-600 to-blue-500'} text-white py-3 overflow-hidden relative`}>
              <div className="container mx-auto px-4 flex items-center justify-between">
                <div className="flex items-center animate-fadeInSlide">
                  <div className="mr-3 text-xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                  </div>
                  <div className="flex-1 overflow-hidden">
                    <div className="animate-marquee whitespace-nowrap">
                      <span className="px-4">New academic year registration is now open!</span>
                      <span className="px-4">🌟 Join us for our annual education fair on March 15th!</span>
                      <span className="px-4">🎓 Scholarship applications deadline approaching!</span>
                      <span className="px-4">🏫 New campus library opens next month!</span>
                    </div>
                  </div>
                </div>
                <button 
                  onClick={() => setHideAnnouncement(true)}
                  className="ml-4 text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-full p-1"
                  aria-label="Close announcement"
                >
                  ✕
                </button>
              </div>
            </div>
          )}
      
      {/* Hero Section */}
      <section id="hero" className={`relative ${darkMode ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900' : 'bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900'} text-white overflow-hidden min-h-screen flex items-center transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ animationDelay: '0ms' }}>
        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden">
          {/* Floating geometric shapes */}
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-600 rounded-full mix-blend-multiply filter blur-xl opacity-10"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-indigo-600 rounded-full mix-blend-multiply filter blur-xl opacity-10"></div>
          <div className="absolute top-1/4 left-1/4 w-32 h-32 border-2 border-white/10 rotate-45 animate-bounce" style={{animationDuration: '15s', animationName: 'float'}}></div>
          <div className="absolute top-1/3 right-1/3 w-24 h-24 bg-purple-500/10 rounded-full animate-bounce" style={{animationDuration: '12s', animationDelay: '2s', animationName: 'float'}}></div>
          <div className="absolute bottom-1/4 left-1/3 w-20 h-20 border-2 border-white/10 rotate-12 animate-bounce" style={{animationDuration: '18s', animationDelay: '4s', animationName: 'float'}}></div>
          <div className="absolute top-1/2 right-1/4 w-16 h-16 bg-pink-500/10 rounded-full animate-bounce" style={{animationDuration: '10s', animationDelay: '1s', animationName: 'float'}}></div>
          
          {/* Gradient mesh effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-500/5 to-transparent animate-pulse"></div>
        </div>
        
        <div className="container mx-auto px-4 py-20 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className={`inline-block backdrop-blur-md ${darkMode ? 'bg-white/10' : 'bg-white/20'} px-6 py-2 rounded-full mb-6 animate-fade-in`}>
              <span className="text-blue-200">🏛️</span>
              <span className="mx-2">•</span>
              <span className="text-sm font-medium">Est. 1998</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight animate-slide-down tracking-tight font-sans">
              Welcome to <span className={`${darkMode ? 'text-blue-300' : 'text-blue-300'} tracking-wide`}>EduManage</span>
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl mb-4 max-w-2xl mx-auto text-blue-100 animate-fade-in delay-300 leading-relaxed">
              Excellence in Education - Shaping Future Leaders
            </p>
            
            <p className="text-sm md:text-base mb-10 max-w-xl mx-auto text-blue-200 italic animate-fade-in delay-500">
              25+ Years of Academic Excellence | Government Recognized Institution
            </p>
            
            {/* Search Bar */}
            <form onSubmit={handleSearch} className="w-96 mx-auto mb-8 max-w-md">
              <div className="relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search courses, events, or resources..."
                  className={`w-full px-4 py-4 pr-16 rounded-full ${darkMode ? 'bg-slate-100/90 text-slate-900' : 'bg-white/90 text-gray-800'} placeholder-gray-600 focus:outline-none focus:ring-4 focus:ring-blue-300/50 shadow-lg text-base h-14`}
                />
                <button 
                  type="submit"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-[#2563EB] text-white p-3 rounded-full hover:bg-[#1D4ED8] transition-colors shadow-lg overflow-hidden"
                  onClick={(e) => {
                    handleRipple(e);
                    handleSearch(e);
                  }}
                >
                  {ripple.active && (
                    <span 
                      className="absolute bg-white/30 rounded-full animate-ripple"
                      style={{
                        width: `${ripple.size}px`,
                        height: `${ripple.size}px`,
                        left: `${ripple.x}px`,
                        top: `${ripple.y}px`,
                      }}
                    ></span>
                  )}
                  🔍
                </button>
              </div>
            </form>
            
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 animate-slide-up delay-700 w-full max-w-2xl mx-auto">
              <Link 
                to="/login" 
                className={`${darkMode ? 'bg-white text-blue-800 hover:bg-blue-50' : 'bg-white text-blue-800 hover:bg-blue-50'} px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-white/50 shadow-lg w-full max-w-[200px] flex items-center justify-center`}
              >
                <span className="mr-2">🔐</span>Login
              </Link>
              <Link 
                to="/admission" 
                className={`${darkMode ? 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700' : 'bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800'} text-white px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-blue-300/50 shadow-lg w-full max-w-[200px] flex items-center justify-center`}
              >
                <span className="mr-2">📝</span>Apply Now
              </Link>
              <Link 
                to="/about" 
                className={`${darkMode ? 'border-2 border-white text-white hover:bg-white hover:text-blue-800' : 'border-2 border-white text-white hover:bg-white hover:text-blue-800'} px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/50 shadow-lg w-full max-w-[200px] flex items-center justify-center`}
              >
                <span className="mr-2">📖</span>Learn More
              </Link>
            </div>
            
            {/* Scroll indicator */}
            <div className="mt-16 animate-bounce flex justify-center">
              <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
                <div className="w-1 h-3 bg-white/50 rounded-full mt-2 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section id="statsSection" className={`py-16 sm:py-20 ${darkMode ? 'bg-gradient-to-b from-gray-800 to-gray-900' : 'bg-gradient-to-b from-white to-blue-50'}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '100ms' }}>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 max-w-6xl mx-auto">
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200/50 hover:bg-blue-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-500 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl relative overflow-hidden group`} style={{ animationDelay: '0ms' }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2563EB] to-[#3b82f6] transform origin-left transition-transform duration-700" style={{
                transform: isVisible.statsSection ? 'scaleX(1)' : 'scaleX(0)',
              }}></div>
              <div className="mb-4 flex justify-center">
                <div className={`w-16 h-16 sm:w-20 sm:h-20 ${darkMode ? 'bg-blue-900/50' : 'bg-blue-100'} rounded-full flex items-center justify-center transition-transform duration-300 hover:rotate-12 hover:scale-110 shadow-inner`}>
                  <span className="text-2xl sm:text-3xl text-[#2563EB]">🎓</span>
                </div>
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-[#2563EB] mb-4 flex justify-center">
                <CountUp end={1250} duration={3} suffix="+" />
              </div>
              <div className="text-[#1E293B] font-bold text-lg sm:text-xl mb-2 font-sans">Students Enrolled</div>
              <div className="text-[#64748B] text-sm sm:text-base font-sans">Active Learners</div>
            </div>
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-emerald-50 to-emerald-100 border border-emerald-200/50 hover:bg-emerald-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-500 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl relative overflow-hidden group`} style={{ animationDelay: '200ms' }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#10B981] to-[#34d399] transform origin-left transition-transform duration-700" style={{
                transform: isVisible.statsSection ? 'scaleX(1)' : 'scaleX(0)',
                transitionDelay: '200ms'
              }}></div>
              <div className="mb-4 flex justify-center">
                <div className={`w-16 h-16 sm:w-20 sm:h-20 ${darkMode ? 'bg-green-900/50' : 'bg-green-100'} rounded-full flex items-center justify-center transition-transform duration-300 hover:rotate-12 hover:scale-110 shadow-inner`}>
                  <span className="text-2xl sm:text-3xl text-[#10B981]">👨‍🏫</span>
                </div>
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-[#10B981] mb-4 flex justify-center">
                <CountUp end={85} duration={3} suffix="+" />
              </div>
              <div className="text-[#1E293B] font-bold text-lg sm:text-xl mb-2 font-sans">Qualified Teachers</div>
              <div className="text-[#64748B] text-sm sm:text-base font-sans">Experienced Faculty</div>
            </div>
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-violet-50 to-purple-100 border border-violet-200/50 hover:bg-purple-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-500 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl relative overflow-hidden group`} style={{ animationDelay: '400ms' }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#8B5CF6] to-[#a78bfa] transform origin-left transition-transform duration-700" style={{
                transform: isVisible.statsSection ? 'scaleX(1)' : 'scaleX(0)',
                transitionDelay: '400ms'
              }}></div>
              <div className="mb-4 flex justify-center">
                <div className={`w-16 h-16 sm:w-20 sm:h-20 ${darkMode ? 'bg-purple-900/50' : 'bg-purple-100'} rounded-full flex items-center justify-center transition-transform duration-300 hover:rotate-12 hover:scale-110 shadow-inner`}>
                  <span className="text-2xl sm:text-3xl text-[#8B5CF6]">🏆</span>
                </div>
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-[#8B5CF6] mb-4 flex justify-center">
                <CountUp end={98} duration={3} suffix="+" />
              </div>
              <div className="text-[#1E293B] font-bold text-lg sm:text-xl mb-2 font-sans">Success Rate</div>
              <div className="text-[#64748B] text-sm sm:text-base font-sans">Pass Percentage</div>
            </div>
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-amber-50 to-orange-100 border border-amber-200/50 hover:bg-orange-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-500 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl relative overflow-hidden group`} style={{ animationDelay: '600ms' }}>
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#F59E0B] to-[#fbbf24] transform origin-left transition-transform duration-700" style={{
                transform: isVisible.statsSection ? 'scaleX(1)' : 'scaleX(0)',
                transitionDelay: '600ms'
              }}></div>
              <div className="mb-4 flex justify-center">
                <div className={`w-16 h-16 sm:w-20 sm:h-20 ${darkMode ? 'bg-orange-900/50' : 'bg-orange-100'} rounded-full flex items-center justify-center transition-transform duration-300 hover:rotate-12 hover:scale-110 shadow-inner`}>
                  <span className="text-2xl sm:text-3xl text-[#F59E0B]">📅</span>
                </div>
              </div>
              <div className="text-4xl sm:text-5xl font-bold text-[#F59E0B] mb-4 flex justify-center">
                <CountUp end={25} duration={3} suffix="+" />
              </div>
              <div className="text-[#1E293B] font-bold text-lg sm:text-xl mb-2 font-sans">Years Experience</div>
              <div className="text-[#64748B] text-sm sm:text-base font-sans">Since 1998</div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className={`py-16 sm:py-20 ${darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-50 to-white'} ${darkMode ? 'text-slate-100' : 'text-gray-800'}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '200ms' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className={`text-3xl sm:text-4xl md:text-5xl font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')} mb-4 font-sans`}>Why Choose EduManage?</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-300 mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-7xl mx-auto">
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200/50 hover:bg-blue-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl border-t-4 border-blue-500 flex flex-col min-h-[280px] sm:min-h-[320px] group focus:outline-none focus:ring-2 focus:ring-blue-300/50`}>
              <div className="mb-4 sm:mb-6 flex justify-center">
                <div className={`w-20 h-20 sm:w-24 sm:h-24 ${darkMode ? 'bg-slate-700/50' : 'bg-blue-100'} rounded-full flex items-center justify-center text-blue-600 transition-transform duration-300 group-hover:rotate-5 group-hover:scale-110 shadow-inner`}>
                  <span className="text-4xl sm:text-5xl">🎓</span>
                </div>
              </div>
              <h3 className={`font-bold text-lg sm:text-xl mb-2 sm:mb-4 ${(darkMode ? 'text-slate-200' : 'text-gray-800')} flex-grow font-sans`}>Quality Education</h3>
              <p className={`text-gray-600 text-sm sm:text-base mb-2 sm:mb-4 flex-grow font-sans ${darkMode ? 'text-slate-300' : ''}`}>Comprehensive curriculum with experienced faculty dedicated to student success.</p>
              <div className="mt-auto">
                <Link to="/about" className="text-[#2563EB] hover:text-[#1D4ED8] font-semibold inline-flex items-center text-sm sm:text-base group focus:outline-none focus:ring-2 focus:ring-blue-300/50">
                  Learn More <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
                </Link>
              </div>
            </div>
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-teal-50 to-emerald-100 border border-teal-200/50 hover:bg-teal-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl border-t-4 border-teal-500 flex flex-col min-h-[280px] sm:min-h-[320px] group focus:outline-none focus:ring-2 focus:ring-teal-300/50`}>
              <div className="mb-4 sm:mb-6 flex justify-center">
                <div className={`w-20 h-20 sm:w-24 sm:h-24 ${darkMode ? 'bg-slate-700/50' : 'bg-teal-100'} rounded-full flex items-center justify-center text-teal-600 transition-transform duration-300 group-hover:rotate-5 group-hover:scale-110 shadow-inner`}>
                  <span className="text-4xl sm:text-5xl">🏫</span>
                </div>
              </div>
              <h3 className={`font-bold text-lg sm:text-xl mb-2 sm:mb-4 ${(darkMode ? 'text-slate-200' : 'text-gray-800')} flex-grow font-sans`}>Modern Infrastructure</h3>
              <p className={`text-gray-600 text-sm sm:text-base mb-2 sm:mb-4 flex-grow font-sans ${darkMode ? 'text-slate-300' : ''}`}>State-of-the-art facilities with advanced technology and learning resources.</p>
              <div className="mt-auto">
                <Link to="/about" className="text-[#2563EB] hover:text-[#1D4ED8] font-semibold inline-flex items-center text-sm sm:text-base group focus:outline-none focus:ring-2 focus:ring-blue-300/50">
                  Learn More <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
                </Link>
              </div>
            </div>
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-amber-50 to-orange-100 border border-amber-200/50 hover:bg-orange-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl border-t-4 border-orange-500 flex flex-col min-h-[280px] sm:min-h-[320px] group focus:outline-none focus:ring-2 focus:ring-orange-300/50`}>
              <div className="mb-4 sm:mb-6 flex justify-center">
                <div className={`w-20 h-20 sm:w-24 sm:h-24 ${darkMode ? 'bg-slate-700/50' : 'bg-orange-100'} rounded-full flex items-center justify-center text-orange-600 transition-transform duration-300 group-hover:rotate-5 group-hover:scale-110 shadow-inner`}>
                  <span className="text-4xl sm:text-5xl">🏆</span>
                </div>
              </div>
              <h3 className={`font-bold text-lg sm:text-xl mb-2 sm:mb-4 ${(darkMode ? 'text-slate-200' : 'text-gray-800')} flex-grow font-sans`}>Proven Results</h3>
              <p className={`text-gray-600 text-sm sm:text-base mb-2 sm:mb-4 flex-grow font-sans ${darkMode ? 'text-slate-300' : ''}`}>Consistent academic excellence with outstanding student achievements.</p>
              <div className="mt-auto">
                <Link to="/results" className="text-[#2563EB] hover:text-[#1D4ED8] font-semibold inline-flex items-center text-sm sm:text-base group focus:outline-none focus:ring-2 focus:ring-blue-300/50">
                  Learn More <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
                </Link>
              </div>
            </div>
            <div className={`backdrop-blur-md ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-violet-50 to-purple-100 border border-violet-200/50 hover:bg-purple-100'} p-6 sm:p-8 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl border-t-4 border-purple-500 flex flex-col min-h-[280px] sm:min-h-[320px] group focus:outline-none focus:ring-2 focus:ring-purple-300/50`}>
              <div className="mb-4 sm:mb-6 flex justify-center">
                <div className={`w-20 h-20 sm:w-24 sm:h-24 ${darkMode ? 'bg-slate-700/50' : 'bg-purple-100'} rounded-full flex items-center justify-center text-purple-600 transition-transform duration-300 group-hover:rotate-5 group-hover:scale-110 shadow-inner`}>
                  <span className="text-4xl sm:text-5xl">👥</span>
                </div>
              </div>
              <h3 className={`font-bold text-lg sm:text-xl mb-2 sm:mb-4 ${(darkMode ? 'text-slate-200' : 'text-gray-800')} flex-grow font-sans`}>Supportive Community</h3>
              <p className={`text-gray-600 text-sm sm:text-base mb-2 sm:mb-4 flex-grow font-sans ${darkMode ? 'text-slate-300' : ''}`}>Engaged parents and dedicated staff fostering growth.</p>
              <div className="mt-auto">
                <Link to="/about" className="text-[#2563EB] hover:text-[#1D4ED8] font-semibold inline-flex items-center text-sm sm:text-base group focus:outline-none focus:ring-2 focus:ring-blue-300/50">
                  Learn More <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Access */}
      <section className={`py-16 sm:py-20 ${darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-50 to-white'} ${darkMode ? 'text-slate-100' : 'text-gray-800'}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '300ms' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className={`text-3xl sm:text-4xl md:text-5xl font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')} mb-4 font-sans`}>Quick Access</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-300 mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 max-w-7xl mx-auto">
            <Link to="/notices" className={`group ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200/50 hover:bg-blue-100'} p-6 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl flex flex-col items-center relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-blue-300/50 backdrop-blur-md cursor-pointer min-h-[150px] min-w-[120px]`}>
              <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 to-blue-200/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 flex items-center justify-center mb-2 rounded-full bg-blue-100 group-hover:scale-110 transition-transform duration-300 ease-in-out group-hover:animate-bounce group-hover:rotate-12 text-[#2563EB] text-2xl" role="img" aria-label="Notices icon">📢</div>
              <h3 className={`font-bold text-base ${(darkMode ? 'text-slate-200' : 'text-gray-800')} mb-1 font-sans`}>Notices</h3>
              <p className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-500'} mb-2 font-sans`}>Announcements</p>
              <div className="text-[#2563EB] text-xs flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>View</span>
                <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </div>
            </Link>
            <Link to="/admission" className={`group ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-emerald-50 to-teal-100 border border-emerald-200/50 hover:bg-emerald-100'} p-6 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl flex flex-col items-center relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-blue-300/50 backdrop-blur-md cursor-pointer min-h-[150px] min-w-[120px]`}>
              <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 to-blue-200/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 flex items-center justify-center mb-2 rounded-full bg-blue-100 group-hover:scale-110 transition-transform duration-300 ease-in-out group-hover:animate-bounce group-hover:rotate-12 text-[#2563EB] text-2xl" role="img" aria-label="Admission icon">📝</div>
              <h3 className={`font-bold text-base ${(darkMode ? 'text-slate-200' : 'text-gray-800')} mb-1 font-sans`}>Admission</h3>
              <p className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-500'} mb-2 font-sans`}>Apply Now</p>
              <div className="text-[#2563EB] text-xs flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>Apply</span>
                <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </div>
            </Link>
            <Link to="/login" className={`group ${darkMode ? 'bg-gradient-to-br from-[#2563EB] to-[#1D4ED8] hover:from-[#1D4ED8] hover:to-[#1a3d7a]' : 'bg-gradient-to-br from-[#2563EB] to-[#1E3A8A] hover:from-[#1E3A8A] hover:to-[#1a316f]'} p-6 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl flex flex-col items-center text-white relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-blue-300/50 cursor-pointer min-h-[150px] min-w-[120px]`}>
              <div className="absolute inset-0 bg-gradient-to-br from-blue-700/50 to-blue-800/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 flex items-center justify-center mb-2 rounded-full bg-blue-200 group-hover:scale-110 transition-transform duration-300 ease-in-out group-hover:animate-bounce group-hover:rotate-12 text-blue-700 text-2xl" role="img" aria-label="Login icon">🔐</div>
              <h3 className="font-bold text-base mb-1 font-sans">Login</h3>
              <p className="text-xs text-blue-200 mb-2 font-sans">Access Portal</p>
              <div className="text-blue-200 text-xs flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>Login</span>
                <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </div>
            </Link>
            <Link to="/teachers" className={`group ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-amber-50 to-orange-100 border border-amber-200/50 hover:bg-amber-100'} p-6 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl flex flex-col items-center relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-blue-300/50 backdrop-blur-md cursor-pointer min-h-[150px] min-w-[120px]`}>
              <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 to-blue-200/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 flex items-center justify-center mb-2 rounded-full bg-blue-100 group-hover:scale-110 transition-transform duration-300 ease-in-out group-hover:animate-bounce group-hover:rotate-12 text-[#2563EB] text-2xl" role="img" aria-label="Teachers icon">👨‍🏫</div>
              <h3 className={`font-bold text-base ${(darkMode ? 'text-slate-200' : 'text-gray-800')} mb-1 font-sans`}>Teachers</h3>
              <p className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-500'} mb-2 font-sans`}>Our Faculty</p>
              <div className="text-[#2563EB] text-xs flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>View</span>
                <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </div>
            </Link>
            <Link to="/results" className={`group ${darkMode ? 'bg-gradient-to-br from-slate-800/60 to-slate-900/60 border border-slate-500/40 hover:bg-slate-800/80' : 'bg-gradient-to-br from-violet-50 to-purple-100 border border-violet-200/50 hover:bg-violet-100'} p-6 rounded-2xl shadow-lg text-center transition-all duration-300 ease-in-out transform hover:-translate-y-3 hover:shadow-2xl flex flex-col items-center relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-blue-300/50 backdrop-blur-md cursor-pointer min-h-[150px] min-w-[120px]`}>
              <div className="absolute inset-0 bg-gradient-to-br from-blue-100/50 to-blue-200/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="w-16 h-16 flex items-center justify-center mb-2 rounded-full bg-blue-100 group-hover:scale-110 transition-transform duration-300 ease-in-out group-hover:animate-bounce group-hover:rotate-12 text-[#2563EB] text-2xl" role="img" aria-label="Results icon">📊</div>
              <h3 className={`font-bold text-base ${(darkMode ? 'text-slate-200' : 'text-gray-800')} mb-1 font-sans`}>Results</h3>
              <p className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-500'} mb-2 font-sans`}>Check Grades</p>
              <div className="text-[#2563EB] text-xs flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span>View</span>
                <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className={`py-16 sm:py-20 ${darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-50 to-white'} ${darkMode ? 'text-slate-100' : 'text-gray-800'}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '400ms' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className={`text-3xl sm:text-4xl md:text-5xl font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')} mb-4 font-sans`}>What Our Community Says</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-300 mx-auto rounded-full"></div>
          </div>
          
          <div className="relative max-w-4xl mx-auto">
            {/* Testimonial Slider */}
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentTestimonial * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="w-full flex-shrink-0">
                    <div className={`rounded-2xl shadow-lg p-8 text-center hover:shadow-2xl transition-shadow duration-300 group ${darkMode ? 'bg-slate-800/40 backdrop-blur-md border border-slate-500/50' : 'bg-white backdrop-blur-md border border-white/20'}`}>
                      <div className={`w-16 h-16 ${darkMode ? 'bg-slate-600/50' : 'bg-blue-100'} rounded-full flex items-center justify-center mx-auto mb-6`}>
                        <span className="text-2xl">{testimonial.avatar}</span>
                      </div>
                      <div className="flex justify-center mb-4">
                        <span className="text-yellow-400 text-xl">
                          {'⭐'.repeat(testimonial.rating)}
                        </span>
                      </div>
                      <p className={`text-gray-600 mb-6 font-sans italic ${(darkMode ? 'text-slate-300' : 'text-gray-600')}`}>{`"${testimonial.content}"`}</p>
                      <div className={`text-gray-800 font-semibold ${(darkMode ? 'text-slate-200' : 'text-gray-800')}`}>- {testimonial.name}, {testimonial.role}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Arrow navigation */}
            <div className="flex justify-between items-center mt-6">
              <button 
                onClick={() => setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
                className="p-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg transition-colors duration-300"
                aria-label="Previous testimonial"
              >
                ❮
              </button>
              
              {/* Slider controls */}
              <div className="flex space-x-2">
                {testimonials.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentTestimonial(index)}
                    className={`w-3 h-3 rounded-full transition-colors ${index === currentTestimonial ? 'bg-blue-600' : 'bg-gray-300'}`}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>
              
              <button 
                onClick={() => setCurrentTestimonial((prev) => (prev + 1) % testimonials.length)}
                className="p-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white shadow-lg transition-colors duration-300"
                aria-label="Next testimonial"
              >
                ❯
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Notices */}
      <section className={`py-16 sm:py-20 ${darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-50 to-white'} ${darkMode ? 'text-slate-100' : 'text-gray-800'}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '500ms' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className={`text-3xl sm:text-4xl md:text-5xl font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')} mb-4 font-sans`}>Latest Notices</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-300 mx-auto rounded-full"></div>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 max-w-7xl mx-auto">
            {notices.length > 0 ? (
              notices.map((notice) => (
                <div key={notice._id} className={`rounded-2xl shadow-lg overflow-hidden transition-all duration-300 ease-in-out transform hover:-translate-y-2 hover:shadow-2xl border-l-4 border-blue-600 hover:border-l-8 group focus:outline-none focus:ring-2 focus:ring-blue-300/50 ${darkMode ? 'bg-slate-800/30 backdrop-blur-md border border-slate-600/50' : 'bg-white/70 backdrop-blur-md border border-white/20'}`}>
                  <div className="p-6 sm:p-8">
                    <div className="flex flex-col sm:flex-row justify-between items-start mb-4 gap-2">
                      <h3 className={`font-bold text-lg sm:text-xl ${(darkMode ? 'text-slate-200' : 'text-gray-800')} line-clamp-2 flex-1 mr-4 font-sans`}>{notice.title}</h3>
                      <span className={`text-xs sm:text-sm px-3 py-1 rounded-full font-semibold ${notice.priority === 'Urgent' ? 'bg-red-100 text-red-800' : notice.priority === 'Important' ? 'bg-orange-100 text-orange-800' : 'bg-green-100 text-green-800'}`}>
                        {notice.priority || 'Normal'}
                      </span>
                    </div>
                    <p className={`text-gray-600 text-sm sm:text-base mb-4 line-clamp-2 font-sans ${(darkMode ? 'text-slate-300' : 'text-gray-600')}`}>{notice.description}</p>
                    <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm gap-2">
                      <div className="flex items-center space-x-2 sm:space-x-4">
                        <span className={`flex items-center ${(darkMode ? 'text-slate-400' : 'text-gray-500')} font-sans`}>
                          <span className="mr-1">📅</span>{new Date(notice.createdAt).toLocaleDateString()}
                        </span>
                        <span className={`flex items-center ${(darkMode ? 'text-slate-400' : 'text-gray-500')} font-sans`}>
                          <span className="mr-1">🔔</span>{notice.category || 'General'}
                        </span>
                      </div>
                      <Link to={`/notices/${notice._id}`} className="text-blue-600 hover:text-blue-800 font-semibold flex items-center group">
                        Read More <span className="ml-1 group-hover:translate-x-1 transition-transform duration-300">→</span>
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center py-12 sm:py-16 text-gray-500">
                <div className="flex justify-center mb-4 sm:mb-6">
                  <div className={`w-20 h-20 sm:w-24 sm:h-24 ${darkMode ? 'bg-blue-900/20' : 'bg-blue-100'} rounded-full flex items-center justify-center`}>
                    <span className="text-4xl sm:text-5xl">📋</span>
                  </div>
                </div>
                <p className={`text-base sm:text-lg mb-1 sm:mb-2 font-sans ${(darkMode ? 'text-slate-300' : 'text-gray-600')}`}>No notices available at the moment.</p>
                <p className={`text-gray-500 font-sans ${(darkMode ? 'text-slate-400' : 'text-gray-500')}`}>Check back later for updates!</p>
              </div>
            )}
          </div>
          
          <div className="text-center mt-12 sm:mt-16">
            <Link to="/notices" className={`inline-flex items-center bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-3 sm:px-10 sm:py-4 rounded-xl font-semibold transition-all duration-300 ease-in-out transform hover:scale-105 hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-xl group focus:outline-none focus:ring-2 focus:ring-blue-300/50 ${darkMode ? 'bg-gradient-to-r from-blue-600 to-purple-600' : ''}`}>
              View All Notices <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className={`py-16 sm:py-20 ${darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-50 to-white'} ${darkMode ? 'text-slate-100' : 'text-gray-800'}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '600ms' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className={`text-3xl sm:text-4xl md:text-5xl font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')} mb-4 font-sans`}>Campus Gallery</h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-blue-300 mx-auto rounded-full"></div>
          </div>
          
          {/* Logo Section */}
          {logoImages.length > 0 && (
            <div className="mb-16">
              <h3 className={`text-2xl sm:text-3xl font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')} mb-8 font-sans text-center`}>Our Logo</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 max-w-7xl mx-auto">
                {logoImages.slice(0, 6).map((image, index) => {
                  const actualIndex = [...logoImages, ...galleryImages].findIndex(img => img._id === image._id);
                  return (
                    <div 
                      key={image._id || image.id} 
                      className={`aspect-square rounded-3xl overflow-hidden cursor-pointer transition-all duration-500 group hover:-translate-y-2 ${darkMode ? 'bg-gradient-to-br from-blue-500/20 to-indigo-600/20 backdrop-blur-md border border-blue-400/30 shadow-lg hover:shadow-2xl hover:shadow-blue-500/20' : 'bg-gradient-to-br from-indigo-100 to-purple-100 backdrop-blur-md border border-indigo-200/50 shadow-lg hover:shadow-2xl hover:shadow-indigo-300/30'}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        openLightbox(actualIndex);
                      }}
                      style={{
                        boxShadow: darkMode ? '0 10px 30px -10px rgba(0,0,0,0.25)' : '0 10px 30px -10px rgba(0,0,0,0.1)',
                        transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
                      }}
                    >
                      <div className="relative w-full h-full p-3">
                        {image.imageUrl ? (
                          <img 
                            src={image.imageUrl} 
                            alt={image.title}
                            className="w-full h-full object-cover rounded-2xl transition-transform duration-500 group-hover:scale-105"
                            loading="lazy"
                          />
                        ) : (
                          <div className="w-full h-full flex items-center justify-center text-blue-600 dark:text-blue-300 text-5xl rounded-2xl bg-white/20 dark:bg-blue-500/10">
                            🏢
                          </div>
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl flex items-center justify-center p-4">
                          <div className="text-white text-center px-2">
                            <h4 className="font-bold text-sm mb-1">{image.title}</h4>
                            <div className="w-8 h-0.5 bg-white/50 mx-auto"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          
          {/* Gallery Section - Enhanced Cards */}
          <div className="mb-16">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
              {galleryImages.slice(0, 4).map((image, index) => {
                const actualIndex = [...logoImages, ...galleryImages].findIndex(img => img._id === image._id);
                return (
                  <div 
                    key={image._id || image.id} 
                    className="rounded-3xl overflow-hidden cursor-pointer transition-all duration-500 group hover:-translate-y-3 shadow-lg hover:shadow-2xl"
                    onClick={(e) => {
                      e.stopPropagation();
                      openLightbox(actualIndex);
                    }}
                    style={{
                      boxShadow: darkMode ? '0 15px 35px -10px rgba(79, 70, 229, 0.2)' : '0 15px 35px -10px rgba(0,0,0,0.15)',
                      transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
                    }}
                  >
                    <div className="relative aspect-square">
                      {image.imageUrl ? (
                        <img 
                          src={image.imageUrl} 
                          alt={image.title}
                          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                          loading="lazy"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-200 to-gray-300 dark:from-blue-400/20 dark:to-indigo-500/20">
                          <div className="text-5xl">
                            {image.category === 'Campus' ? '📚' : image.category === 'Academic' ? '🏫' : image.category === 'Events' ? '🎉' : '⚽'}
                          </div>
                        </div>
                      )}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end">
                        <div className="p-4 w-full">
                          <h4 className="font-bold text-white text-base text-center transition-all duration-300 group-hover:mb-2">{image.title}</h4>
                          <div className="w-12 h-0.5 bg-white/50 mx-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={`py-16 ${(darkMode ? 'bg-gradient-to-b from-slate-900 to-slate-800' : 'bg-gradient-to-b from-blue-900 to-indigo-900')} ${(darkMode ? 'text-slate-100' : 'text-white')}`} style={{ animation: isPageLoaded ? 'fadeInUp 0.6s ease-out forwards' : 'none', animationDelay: '800ms' }}>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 max-w-7xl mx-auto">
            <div>
              <h3 className={`text-2xl font-bold mb-4 font-sans flex items-center ${(darkMode ? 'text-slate-100' : 'text-white')}`}>
                <span className="mr-2">🎓</span>EduManage
              </h3>
              <p className={`${(darkMode ? 'text-slate-300' : 'text-gray-300')} mb-6`}>Shaping future leaders with excellence in education since 1998.</p>
              <div className="flex space-x-4">
                <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:scale-110 transition-transform duration-300 ease-in-out shadow-lg hover:shadow-xl">
                  <span className="text-lg">📘</span>
                </a>
                <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-blue-400 to-indigo-600 text-white hover:scale-110 transition-transform duration-300 ease-in-out shadow-lg hover:shadow-xl">
                  <span className="text-lg">🐦</span>
                </a>
                <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:scale-110 transition-transform duration-300 ease-in-out shadow-lg hover:shadow-xl">
                  <span className="text-lg">📷</span>
                </a>
                <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white hover:scale-110 transition-transform duration-300 ease-in-out shadow-lg hover:shadow-xl">
                  <span className="text-lg">💼</span>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className={`text-xl font-bold mb-6 font-sans flex items-center ${(darkMode ? 'text-slate-100' : 'text-white')}`}>
                <span className="mr-2">🔗</span>Quick Links
              </h4>
              <ul className="space-y-3">
                <li><button onClick={() => document.getElementById('hero').scrollIntoView({ behavior: 'smooth' })} className={`block ${(darkMode ? 'text-slate-300' : 'text-gray-300')} hover:text-white transition-colors link-underline py-1 text-left w-full`}>Home</button></li>
                <li><Link to="/about" className={`block ${(darkMode ? 'text-slate-300' : 'text-gray-300')} hover:text-white transition-colors link-underline py-1`}>About Us</Link></li>
                <li><Link to="/courses" className={`block ${(darkMode ? 'text-slate-300' : 'text-gray-300')} hover:text-white transition-colors link-underline py-1`}>Courses</Link></li>
                <li><Link to="/admission" className={`block ${(darkMode ? 'text-slate-300' : 'text-gray-300')} hover:text-white transition-colors link-underline py-1`}>Admission</Link></li>
                <li><Link to="/contact" className={`block ${(darkMode ? 'text-slate-300' : 'text-gray-300')} hover:text-white transition-colors link-underline py-1`}>Contact</Link></li>
              </ul>
            </div>
            
            <div>
              <h4 className={`text-xl font-bold mb-6 font-sans flex items-center ${(darkMode ? 'text-slate-100' : 'text-white')}`}>
                <span className="mr-2">📞</span>Contact Info
              </h4>
              <ul className={`space-y-3 ${(darkMode ? 'text-slate-300' : 'text-gray-300')}`}>
                <li className="flex items-start">
                  <span className="mr-3 mt-1">📍</span>
                  <span>123 Education Street, City</span>
                </li>
                <li className="flex items-center">
                  <span className="mr-3">📞</span>
                  <span>+1 (555) 123-4567</span>
                </li>
                <li className="flex items-center">
                  <span className="mr-3">✉️</span>
                  <span>info@edumanage.edu</span>
                </li>
                <li className="flex items-center">
                  <span className="mr-3">🕒</span>
                  <span>Mon-Fri: 9AM-5PM</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className={`text-xl font-bold mb-6 font-sans flex items-center ${(darkMode ? 'text-slate-100' : 'text-white')}`}>
                <span className="mr-2">📰</span>Newsletter
              </h4>
              <p className={`${(darkMode ? 'text-slate-300' : 'text-gray-300')} mb-6`}>Subscribe to get updates and news</p>
              <form className="space-y-4">
                <div className="relative">
                  <input 
                    type="email" 
                    placeholder="Enter your email" 
                    className={`w-full px-5 py-4 rounded-xl ${(darkMode ? 'bg-slate-800/50 text-white placeholder-slate-400' : 'bg-white/10 text-white placeholder-white/70')} focus:outline-none focus:ring-2 focus:ring-blue-400 h-14`}
                  />
                  <span className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">📧</span>
                </div>
                <button 
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-4 rounded-xl hover:from-blue-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-[1.02] shadow-lg hover:shadow-xl font-bold text-lg"
                >
                  Subscribe Now
                </button>
              </form>
            </div>
          </div>
          
          <div className={`border-t ${(darkMode ? 'border-slate-700' : 'border-blue-700')} mt-16 pt-8 text-center ${(darkMode ? 'text-slate-400' : 'text-gray-400')}`}>            
            <div className="flex flex-col md:flex-row justify-between items-center max-w-7xl mx-auto">
              <p className="mb-4 md:mb-0">&copy; 2026 EduManage by Yuki. All rights reserved.</p>
              <div className="flex space-x-6">
                <Link to="/privacy" className={`${(darkMode ? 'text-slate-400' : 'text-gray-400')} hover:text-white transition-colors link-underline`}>Privacy Policy</Link>
                <Link to="/terms" className={`${(darkMode ? 'text-slate-400' : 'text-gray-400')} hover:text-white transition-colors link-underline`}>Terms of Service</Link>
                <Link to="/sitemap" className={`${(darkMode ? 'text-slate-400' : 'text-gray-400')} hover:text-white transition-colors link-underline`}>Sitemap</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Lightbox */}
      {lightboxOpen && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <div 
            className="relative max-w-6xl max-h-full w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              onClick={closeLightbox}
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 z-10"
            >
              ✕
            </button>
            <div className={`${(darkMode ? 'text-slate-100' : 'text-white')} text-center mb-4 text-lg`}>
              {(selectedImage && selectedImage.title) || (galleryImages[currentGalleryIndex] && galleryImages[currentGalleryIndex].title) || 'Image'}
            </div>
            {(selectedImage && selectedImage.imageUrl) || (galleryImages[currentGalleryIndex] && galleryImages[currentGalleryIndex].imageUrl) ? (
              <img 
                src={(selectedImage && selectedImage.imageUrl) || (galleryImages[currentGalleryIndex] && galleryImages[currentGalleryIndex].imageUrl) || ''} 
                alt={(selectedImage && selectedImage.title) || (galleryImages[currentGalleryIndex] && galleryImages[currentGalleryIndex].title) || 'Image'}
                className="max-w-full max-h-[80vh] object-contain mx-auto"
                loading="lazy"
              />
            ) : (
              <div className="text-9xl text-white flex items-center justify-center h-[80vh]">
                🏫
              </div>
            )}
            <div 
              className="absolute top-1/2 left-4 transform -translate-y-1/2 text-blue-600 text-4xl cursor-pointer bg-white/30 rounded-full w-12 h-12 flex items-center justify-center hover:bg-white/50 transition-colors"
              onClick={(e) => { e.stopPropagation(); prevImage(); }}
              aria-label="Previous image"
              tabIndex="0"
            >
              ❮
            </div>
            <div 
              className="absolute top-1/2 right-4 transform -translate-y-1/2 text-blue-600 text-4xl cursor-pointer bg-white/30 rounded-full w-12 h-12 flex items-center justify-center hover:bg-white/50 transition-colors"
              onClick={(e) => { e.stopPropagation(); nextImage(); }}
              aria-label="Next image"
              tabIndex="0"
            >
              ❯
            </div>
          </div>
        </div>
      )}
      
      {/* Chatbot Button */}
      <button 
        onClick={() => setShowChatbot(!showChatbot)}
        className="fixed bottom-6 right-6 w-16 h-16 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full flex items-center justify-center text-xl shadow-lg hover:scale-110 transition-transform duration-300 z-50"
      >
        💬
      </button>
      
      {/* Chatbot Panel */}
      {showChatbot && (
        <div className={`fixed bottom-20 right-6 w-80 h-96 ${darkMode ? 'bg-slate-800/90 backdrop-blur-md border border-slate-600/30' : 'bg-white/90 backdrop-blur-md border border-white/20'} rounded-xl shadow-xl border border-gray-200 z-50 p-4`}>
          <div className="flex justify-between items-center mb-4 border-b pb-2">
            <h3 className={`font-bold ${(darkMode ? 'text-slate-100' : 'text-gray-800')}`}>Help Assistant</h3>
            <button 
              onClick={() => setShowChatbot(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>
          <div className="h-64 overflow-y-auto mb-2">
            <div className={`text-sm ${(darkMode ? 'text-slate-300' : 'text-gray-600')} mb-2`}>Hello! How can I help you today?</div>
          </div>
          <div className="flex">
            <input 
              type="text" 
              placeholder="Type your question..."
              className={`flex-1 border ${(darkMode ? 'border-slate-600 bg-slate-700 text-white' : 'border-gray-300')} rounded-l-lg px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500`}
            />
            <button className="bg-blue-600 text-white px-4 py-2 rounded-r-lg text-sm hover:bg-blue-700">
              Send
            </button>
          </div>
        </div>
      )}
        </>
      )}
      <ScrollToTopButton />
    </div>
  );
};

export default Home;